import { AppSubdomains } from 'src/types/common';
import { RouteProtectionProps } from '../types/routeProtection.types';
import { specializedStoresConfig } from '../config/specializedStores.config';
import { getSubdomain } from 'src/utils/domain/getSubdomain';

const UNAUTHENTICATED_ROUTES = [
  '/',
  '/products',
  '/categories',
  '/promociones',
  '/brands',
  '/brands/:brandSlug/products',
  '/highlighted',
  '*',
];

const normalize = (p: string) => {
  if (p === '/') return '/';
  return p.replace(/\/+$/, '');
};

const makeParamRouteRegex = (route: string) =>
  new RegExp('^' + route.replace(/:[^/]+/g, '[^/]+') + '$');

const matchesParamRoute = (route: string, path: string) =>
  route.includes(':') && makeParamRouteRegex(route).test(path);

const matchesExactOrNestedRoute = (route: string, path: string) =>
  path === route || path.startsWith(`${route}/`);

const getIsPublicRoute = (path: string) => {
  return UNAUTHENTICATED_ROUTES.some((route) => {
    const normRoute = normalize(route);
    return (
      matchesParamRoute(route, path) ||
      matchesExactOrNestedRoute(normRoute, path)
    );
  });
};

export function getRouteProtections(path: string): RouteProtectionProps {
  const rawPath = path;
  const normPath = normalize(rawPath);

  const allSubdomains = Object.values(AppSubdomains);
  const current = getSubdomain(AppSubdomains, AppSubdomains.Pari);
  const cfg = specializedStoresConfig.find((c) => c.subdomain === current);
  const isPublicRoute = getIsPublicRoute(normPath);

  if (!cfg) {
    return {
      includedSubdomains: allSubdomains,
      excludedSubdomains: [],
      disableAuthProtection: isPublicRoute ? true : false,
    };
  }

  const exc = cfg.exceptions.find((e) => normalize(e.path) === normPath);
  const disableAuthProtection =
    exc?.props.disableAuthProtection ?? isPublicRoute;

  if (exc) {
    return {
      includedSubdomains: exc.props.includedSubdomains ?? [],
      excludedSubdomains: exc.props.excludedSubdomains ?? [],
      disableAuthProtection,
    };
  }

  if (cfg.strategy === 'exclude') {
    return {
      includedSubdomains: [],
      excludedSubdomains: allSubdomains,
      disableAuthProtection,
    };
  } else {
    return {
      includedSubdomains: allSubdomains,
      excludedSubdomains: [],
      disableAuthProtection,
    };
  }
}
